import { isNullish } from "radashi";

export function compareOutputValues(
  a: (number | string)[] | null | undefined,
  b: (number | string)[] | null | undefined,
): number {
  if (isNullish(a) && isNullish(b)) return 0;
  if (isNullish(a)) return 1;
  if (isNullish(b)) return -1;

  const len = Math.min(a.length, b.length);

  for (let i = 0; i < len; i++) {
    const cmp = compareValues(a[i], b[i]);
    if (cmp !== 0) return cmp;
  }

  return a.length - b.length;
}

function compareValues(a: number | string, b: number | string): number {
  if (typeof a === "number" && typeof b === "number") {
    return a - b;
  }
  if (typeof a === "string" && typeof b === "string") {
    return a.localeCompare(b);
  }
  return String(a).localeCompare(String(b));
}
